import React from 'react';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { Box } from '@mui/material';

// @ts-ignore
const ContainerStyles = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  ' & .pintura-editor': {
    '--color-background': '236, 241, 252',
    '--color-foreground': '15, 96, 255',
    '--font-family':
      '"NIVEAEditorBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"',
    '--font-size': '22px',
    '--font-weight': '500',
  },
  '& .b-grid-header': {},
  '& .PinturaUtilFooter, .PinturaUtilHeader': {
    // display: 'none',
    padding: '0',
  },
  '& .PinturaUtilFooter>[slot]:empty': {
    minHeight: '1px',
  },
  '& .PinturaUtilPanel': {
    // padding: '0',
  },
  '& .PinturaUtilMain': {
    // padding: '0',
  },
  '& .PinturaRoot[data-env~=short] .PinturaUtilPanel[data-util=crop] .PinturaUtilFooter':
    {
      padding: '0',
    },
}));

type Props = {
  sx?: SxProps;
  children: React.ReactNode;
};

export const ImageEditorStylesWrapper = ({
  children,
  sx,
  ...rest
}: Props &
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >) => {
  return (
    <ContainerStyles sx={sx} {...rest}>
      {children}
    </ContainerStyles>
  );
};

ImageEditorStylesWrapper.displayName = 'ImageEditorStylesWrapper';
